import { FC, useState } from "react";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import {
  Add,
  DeleteForever,
  Description,
  GppGood,
  NoteAdd,
} from "@mui/icons-material";
import { PdfData } from "@/models/pdfData";
import { Views } from "@/models/gameGeneral";
import ValidateGamesDialog from "@components/dialogs/ValidateGamesDialog";
import DeleteEverythingDialog from "@components/dialogs/DeleteEverythingDialog";
import SelectGameWizard from "@components/dialogs/new-game/SelectGameWizard";
import CreateGameWizard from "@components/dialogs/new-game/CreateGameWizard";

const style = {
  margin: 0,
  top: "auto",
  right: 20,
  bottom: 20,
  left: "auto",
  position: "fixed",
};

const FabSpeeddial: FC<{
  onCreateGame: (
    game: Pick<PdfData, "scope" | "samsId">,
    destination: Views,
  ) => void;
  onCreateEmpty: () => void;
}> = ({ onCreateGame, onCreateEmpty }) => {
  const [openNewGameWizard, setOpenNewGameWizard] = useState(false);
  const [openSelectGameWizard, setOpenSelectGameWizard] = useState(false);
  const [openValidation, setOpenValidation] = useState(false);
  const [openDeleteEverything, setOpenDeleteEverything] = useState(false);

  const handleCloseNewGameWizard = () => setOpenNewGameWizard(false);
  const handleOpenNewGameWizard = () => setOpenNewGameWizard(true);

  const handleCloseSelectGameWizard = () => setOpenSelectGameWizard(false);
  const handleOpenSelectGameWizard = () => setOpenSelectGameWizard(true);

  const handleOpenValidation = () => setOpenValidation(true);
  const handleCloseValidation = () => setOpenValidation(false);

  const handleOpenDeleteEverything = () => setOpenDeleteEverything(true);
  const handleCloseDeleteEverything = () => setOpenDeleteEverything(false);

  return (
    <>
      <SpeedDial
        color="secondary"
        sx={style}
        ariaLabel={"SpeedDial"}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          key={"selectGame"}
          icon={<Add />}
          slotProps={{
            tooltip: {
              open: true,
              title: "Spiel auswählen",
              sx: { width: "fit-content" },
            },
          }}
          onClick={handleOpenSelectGameWizard}
        />
        <SpeedDialAction
          key={"newGame"}
          icon={<NoteAdd />}
          tooltipTitle={"Neues Spiel erstellen"}
          onClick={handleOpenNewGameWizard}
        />
        <SpeedDialAction
          key={"emptyProtocol"}
          icon={<Description />}
          tooltipTitle={"Leeres Protokoll"}
          onClick={onCreateEmpty}
        />
        <SpeedDialAction
          key={"deleteEverything"}
          icon={<DeleteForever />}
          tooltipTitle={"Alles löschen"}
          onClick={handleOpenDeleteEverything}
        />
        {process.env.NODE_ENV === "development" && (
          <SpeedDialAction
            key={"testGames"}
            icon={<GppGood />}
            tooltipTitle={"Spiele validieren"}
            onClick={handleOpenValidation}
          />
        )}
      </SpeedDial>
      <CreateGameWizard
        open={openNewGameWizard}
        handleClose={handleCloseNewGameWizard}
        onCreateGame={(game, destination) => {
          handleCloseNewGameWizard();
          onCreateGame(game, destination);
        }}
      />
      <SelectGameWizard
        open={openSelectGameWizard}
        handleClose={handleCloseSelectGameWizard}
        onCreateGame={(game, destination) => {
          handleCloseSelectGameWizard();
          onCreateGame(game, destination);
        }}
      />

      <DeleteEverythingDialog
        open={openDeleteEverything}
        handleClose={handleCloseDeleteEverything}
      />

      {process.env.NODE_ENV === "development" && (
        <ValidateGamesDialog
          open={openValidation}
          handleClose={handleCloseValidation}
        ></ValidateGamesDialog>
      )}
    </>
  );
};

export default FabSpeeddial;
